import { Table } from '@mantine/core';

import { aiPromptTemplatesTypes } from '../../types';

import { BodyRow } from './BodyRow';

type Props = {
  templates: aiPromptTemplatesTypes.AIPromptTemplate[];
};

export const AIPromptTemplatesTable = ({ templates }: Props) => {
  return (
    <Table stickyHeader striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>AI ID</Table.Th>
          <Table.Th>Template</Table.Th>
          <Table.Th>Actions</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {templates.map((template) => (
          <BodyRow key={template._id} template={template} />
        ))}
      </Table.Tbody>
    </Table>
  );
};
